import React from 'react';
import './TeamSection.css';

const TeamSection = () => {
  return (
    <section className="team-section fade-in" id="qui-sommes-nous">
      <div className="team-container">
        <h2 className="heading-art-deco team-title">
          Qui sommes-nous?
        </h2>

        <div className="team-portrait">
          <img src="/images/team-portrait.jpg" alt="Team Portrait" />
        </div>

        <p className="team-subtitle">
          Deux experts en retail, e-commerce et nouvelles technologies. Un gars, une fille, animés par les tendances de l'écosystème, en France et à l'international.
        </p>

        <div className="team-grid">
          <div className="team-member slide-up">
            <div className="team-member-left">
              <a href="https://www.linkedin.com/in/laetitialamari/" target="_blank" rel="noopener noreferrer" className="team-member-image-link">
                <img src="/images/laetitia.png" alt="Laetitia Lamari" className="team-member-photo" />
              </a>
              <h3 className="team-member-name">Laetitia Lamari</h3>
            </div>
            <div className="team-member-content">
              <p className="team-member-bio">
                Laetitia est une spécialiste accomplie en marketing dans le secteur du commerce, avec 15 ans d'expérience couvrant diverses facettes de cette industrie dynamique. Elle a contribué à façonner les stratégies marketing pour des entreprises allant des startups aux multinationales. Passionnée par l'innovation et l'impact social du commerce, Laetitia est également une conférencière appréciée et une référence en marketing.
              </p>
              <p className="team-member-bio">
                Co-créatrice du podcast « Le Café De l'E-commerce », elle joue un rôle vital en mettant en lumière les dernières tendances et opportunités dans le monde du e-commerce.
              </p>
            </div>
          </div>

          <div className="team-member slide-up">
            <div className="team-member-left">
              <a href="https://www.linkedin.com/in/adriennaeem/" target="_blank" rel="noopener noreferrer" className="team-member-image-link">
                <img src="/images/adrien.png" alt="Adrien Naeem" className="team-member-photo" />
              </a>
              <h3 className="team-member-name">Adrien Naeem</h3>
            </div>
            <div className="team-member-content">
              <p className="team-member-bio">
                Adrien est un expert en commerce électronique qui a joué un rôle clé dans le lancement de Salesforce Commerce Cloud en France en 2010. Avec 15 ans d'expérience dans des entreprises SaaS américaines, il est également un conférencier reconnu, un influenceur notable sur LinkedIn, et s'investit en tant que bénévole pour l'inclusion numérique. En outre, il est cofondateur de « Le Café De l'Ecommerce », le premier média indépendant dans le domaine de l'e-commerce.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
